<ion-header #header>
    <leplace-toolbar [menu]="false" [title]="title" [leftButton]="appIconsStandard.home"
        [leftButtonDisabled]="linkPreview" [leftIcon]="true" (leftClick)="back()" rightButton="settings"
        [rightIcon]="true" (rightClick)="presentPopover()" [loading]="false">
    </leplace-toolbar>
</ion-header>

<!-- overflow-scroll="true" -->

<ion-content [ngClass]="theme" #content>
    <!-- (swipe)="swipeEvent($event)" -->
    <div class="view-frame view-frame-border">
        <!-- bg-filter-1 -->
        <div class="bg-container bg-container-fill"
            [photoBg]="{fade: true, fadeClass: 'bg-container-fade', url: photoUrl}">

            <div class="content text-color-overlay">

                <div *ngIf="!loaded" class="progress-spinner-center">
                    <mat-progress-spinner [diameter]="40" color="primary" mode="indeterminate">
                    </mat-progress-spinner>
                </div>

                <div *ngIf="loaded" fxLayout="column" class="content-height no-scroll">

                    <div class="scrollbar-y content-height" fxLayout="column" (scroll)='onContentScroll($event)'>

                        <div class="text-color-overlay-flush margin-horizontal-s margin-top-s margin-bottom-s">

                            <ion-row>
                                <ion-col class="padding-s center-text">
                                    <span class="center-text info-text-lg bold text-color-primary">Contact</span>
                                </ion-col>
                            </ion-row>

                            <ion-row *ngIf="infoText.reviewContact" class="center-items">
                                <ion-col size="2">
                                    <img [src]="infoText.reviewContactIcon" class="img-xxs" />
                                </ion-col>
                                <ion-col size="10">
                                    <div [innerHTML]="infoText.reviewContact"
                                        class="info-text-m description-frame text-color-primary text-left">
                                    </div>
                                </ion-col>
                            </ion-row>

                            <div>
                                <ion-grid class="full-w">
                                    <ion-row>
                                        <ion-col size="6">
                                            <ion-button
                                                class="as-text full-w element-selector height-auto text-transform-none"
                                                (click)="openWebpage()">
                                                <span class="button-font-size-s">WEB</span>
                                                <icon-wrapper slot="start" icon="globe" class="slot-icon-padding">
                                                </icon-wrapper>
                                            </ion-button>
                                        </ion-col>
                                        <ion-col size="6">
                                            <ion-button
                                                class="as-text full-w element-selector height-auto text-transform-none"
                                                (click)="contact()">
                                                <span class="button-font-size-s">EMAIL</span>
                                                <icon-wrapper slot="start" icon="mail" class="slot-icon-padding">
                                                </icon-wrapper>
                                            </ion-button>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </div>
                        </div>

                        <ion-row>
                            <ion-col class="padding-s center-text">
                                <span class="center-text info-text-lg bold text-color-primary">Activation Guide</span>
                            </ion-col>
                        </ion-row>

                        <div class="text-color-overlay-flush margin-horizontal-s margin-top-s margin-bottom-s">
                            <div *ngIf="extDataLoaded">
                                <div class="text-left margin-horizontal-s margin-top-s">
                                    <div *ngFor="let e of faqActivation.faqEntries"
                                        class="list-item list-item-padding transparent-bg">
                                        <div class="center-text margin-top-s">
                                            <span class="info-text-m bold text-color-primary">{{e.name}}</span>
                                        </div>
                                        <plain-entry-expand [e]="e" [fixed]="true"></plain-entry-expand>
                                    </div>
                                </div>
                            </div>
                            <booking-check *ngIf="settings" [settings]="settings"
                                (action)="bookingCheckAction($event)"></booking-check>
                        </div>

                        <div id="sectionActivate">
                            <ion-row>
                                <ion-col class="padding-s center-text">
                                    <span class="center-text info-text-lg bold text-color-primary">Get Leplace
                                        World</span>
                                </ion-col>
                            </ion-row>

                            <!-- <div class="padding-s info-text-m description-frame text-color-primary text-left"
                                [innerHTML]="infoText.appNotes">
                            </div> -->

                            <div class="text-color-overlay-flush margin-horizontal-s margin-top-s margin-bottom-s">
                                <div>
                                    <ion-row>
                                        <ion-col class="padding-s center-text">
                                            <span class="center-text info-text-m bold text-color-primary">Public access
                                                (limited
                                                distribution)</span>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12" size-md="6" class="flex-column">
                                            <ion-button class="as-text element-selector height-auto"
                                                [disabled]="!dist.android" (click)="goToPlayStore()">
                                                <img [src]="imgIcons.playStore" class="img-xs" />
                                            </ion-button>
                                            <!-- <span *ngIf="!dist.android"
                                      class="center-text info-text-m bold text-color-primary">(unavailable)</span> -->
                                        </ion-col>
                                        <ion-col size="12" size-md="6" class="flex-column">
                                            <ion-button class="as-text element-selector height-auto"
                                                [disabled]="!isAppStore()" (click)="goToAppStore()">
                                                <img [src]="imgIcons.appStore" class="img-xs" />
                                            </ion-button>
                                            <div class="info-text-m description-frame text-color-primary text-left"
                                                [innerHTML]="infoText.appStoreNotes"></div>
                                            <!-- <span *ngIf="!dist.ios || isTestFlightOnly"
                                              class="center-text info-text-m bold text-color-primary">(unavailable)</span> -->
                                        </ion-col>

                                    </ion-row>
                                </div>

                                <div class="theme-border-top margin-vertical-s">
                                    <ion-row>
                                        <ion-col class="padding-s center-text">
                                            <span class="center-text info-text-m bold text-color-primary">Early access
                                                (worldwide)</span>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12" size-md="6">
                                            <ion-button class="as-text element-selector height-auto"
                                                (click)="goToAppleTestFlight()">
                                                <img [src]="imgIcons.testFlight" class="img-xs" />
                                            </ion-button>
                                        </ion-col>
                                        <ion-col size="12" size-md="6">
                                            <div class="info-text-m description-frame text-color-primary text-left"
                                                [innerHTML]="infoText.testFlightNotes"></div>
                                        </ion-col>
                                    </ion-row>
                                </div>

                                <div class="theme-border-top margin-vertical-s">
                                    <ion-row>
                                        <ion-col class="padding-s center-text">
                                            <span class="center-text info-text-m bold text-color-primary">Web
                                                (worldwide)</span>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12" size-md="6">
                                            <ion-button class="as-text element-selector height-auto"
                                                (click)="goToWeb()">
                                                <img [src]="imgIcons.web" class="img-xs" />
                                            </ion-button>
                                        </ion-col>
                                        <ion-col size="12" size-md="6">
                                            <div class="info-text-m description-frame text-color-primary text-left"
                                                [innerHTML]="infoText.webNotes">
                                            </div>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12">
                                            <ion-button class="as-text element-selector height-auto text-transform-none"
                                                (click)="goToWeb()">
                                                <span class="button-font-size-s">{{webUrlDisp}}</span>
                                                <icon-wrapper slot="start" icon="globe" class="slot-icon-padding">
                                                </icon-wrapper>
                                            </ion-button>
                                        </ion-col>
                                    </ion-row>
                                </div>

                                <!-- <ion-row class="padding-vertical-none">
                              <ion-col size="6" class="padding-vertical-none">
                                <span class="info-text-s">Play Store</span>
                              </ion-col>
                              <ion-col size="6" class="padding-vertical-none">
                                <span class="info-text-s">Apple Test Flight</span>
                              </ion-col>
                            </ion-row> -->

                                <!-- <ion-row>
                                    <ion-col size="12">
                                        <ion-button class="as-text element-selector height-auto text-transform-none"
                                            (click)="openWebpage()">
                                            <span class="button-font-size-s">www.leplace.online</span>
                                            <icon-wrapper slot="start" icon="globe" class="slot-icon-padding">
                                            </icon-wrapper>
                                        </ion-button>
                                    </ion-col>
                                </ion-row> -->
                            </div>
                        </div>


                        <!-- text-color-overlay-flush  -->

                        <div class="margin-horizontal-s margin-top-m margin-bottom-s" *ngIf="extDataLoaded">
                            <div class="text-left">
                                <div class="center-text margin-top-s">
                                    <span class="info-text-mlg bold text-color-primary">Notes</span>
                                </div>
                                <div *ngFor="let fc of faqCategories"
                                    class="list-item list-item-padding transparent-bg">
                                    <div *ngFor="let e of fc.faqEntries"
                                        class="list-item list-item-padding transparent-bg">
                                        <plain-entry-expand [e]="e" [fixed]="true"></plain-entry-expand>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ion-row>
                            <ion-col size="2">
                                <ion-button class="as-text full-w element-selector height-auto text-transform-none"
                                    (click)="openFBPage()">
                                    <!-- <span class="button-font-size-s">Facebook</span> -->
                                    <icon-wrapper slot="icon-only" icon="logo-facebook">
                                    </icon-wrapper>
                                </ion-button>
                            </ion-col>
                            <ion-col size="8">
                                <ion-button class="as-text full-w element-selector height-auto text-transform-none"
                                    (click)="openWebpage()">
                                    <icon-wrapper slot="icon-only" icon="globe">
                                    </icon-wrapper>
                                </ion-button>
                            </ion-col>
                            <ion-col size="2">
                                <ion-button class="as-text full-w element-selector height-auto text-transform-none"
                                    (click)="contact()">
                                    <!-- <span class="button-font-size-s">Email</span> -->
                                    <icon-wrapper slot="icon-only" icon="mail">
                                    </icon-wrapper>
                                </ion-button>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12">
                                <ion-button class="as-text element-selector height-auto text-transform-none"
                                    (click)="openWebpage()">
                                    <span class="button-font-size-s">www.leplace.online</span>
                                </ion-button>
                            </ion-col>
                        </ion-row>

                    </div>
                </div>
            </div>
        </div>
    </div>
</ion-content>